var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:[
        _vm.$style.intro,
        _vm.position === 'center' ? _vm.$style.positionCenter : '',
        _vm.size === 'large' ? _vm.$style.sizeLarge : '' ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }